"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoidMenu = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ui_1 = require("@jsonjoy.com/ui");
const slate_react_1 = require("slate-react");
const hr_1 = require("../behavior/hr");
const toc_1 = require("../behavior/toc");
const math_1 = require("../behavior/math");
const box_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/box"));
const separator_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/separator"));
const file_upload_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/file-upload"));
const list_tree_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/list-tree"));
const math_function_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/math-function"));
// const EmbedIcon = makeIcon({set: 'lucide', icon: 'link-2', width: 16, height: 16});
const EmbedIcon = (props) => (React.createElement(box_1.default, { width: 16, height: 16, ...props }));
const HrIcon = (props) => React.createElement(separator_1.default, { width: 16, height: 16, ...props });
const FileIcon = (props) => (React.createElement(file_upload_1.default, { width: 16, height: 16, ...props }));
// const TocIcon = makeIcon({set: 'bootstrap', icon: 'list-columns-reverse', width: 16, height: 16});
const TocIcon = (props) => React.createElement(list_tree_1.default, { width: 16, height: 16, ...props });
const MathIcon = (props) => (React.createElement(math_function_1.default, { width: 16, height: 16, ...props }));
class VoidMenu {
    constructor(mutxt) {
        this.mutxt = mutxt;
    }
    start() {
        return () => { };
    }
    build() {
        return {
            name: 'Insert menu',
            children: [
                this.itemEmbed({ anchorFromCaret: true }),
                this.itemFile({ anchorFromCaret: true }),
                this.itemMath({ anchorFromCaret: true }),
                this.itemHr(),
                this.itemToc(),
            ],
        };
    }
    buildToolbarMenu() {
        return {
            name: 'Void menu',
            children: [
                {
                    name: 'Insert menu',
                    expand: 2,
                    children: [this.itemEmbed(), this.itemFile(), this.itemMath(), this.itemHr(), this.itemToc()],
                },
            ],
        };
    }
    itemHr() {
        const mutxt = this.mutxt;
        return {
            name: 'Separator',
            text: 'hr horizontal rule line divider break thematic',
            icon: () => React.createElement(HrIcon, null),
            disabled: ui_1.rsync.comp([mutxt.readOnly], ([readOnly]) => !!readOnly),
            onSelect: (event) => {
                event.preventDefault();
                if (mutxt.readOnly.value)
                    return;
                mutxt.voids.open.set(false);
                (0, hr_1.insertHr)(mutxt.editor);
                slate_react_1.ReactEditor.focus(mutxt.editor);
                mutxt.setFocused(true);
                mutxt.sync(true);
            },
        };
    }
    itemToc() {
        const mutxt = this.mutxt;
        return {
            name: 'Table of contents',
            text: 'toc index outline navigation headings summary contents',
            icon: () => React.createElement(TocIcon, null),
            disabled: ui_1.rsync.comp([mutxt.readOnly], ([readOnly]) => !!readOnly),
            onSelect: (event) => {
                event.preventDefault();
                if (mutxt.readOnly.value)
                    return;
                mutxt.voids.open.set(false);
                (0, toc_1.insertToc)(mutxt.editor);
                slate_react_1.ReactEditor.focus(mutxt.editor);
                mutxt.setFocused(true);
                mutxt.sync(true);
            },
        };
    }
    itemFile(opts = {}) {
        const mutxt = this.mutxt;
        const file = mutxt.voids.file;
        return {
            name: 'File',
            text: 'attachment upload image picture photo video audio media document pdf',
            icon: () => React.createElement(FileIcon, null),
            disabled: ui_1.rsync.comp([file.canOpen], ([canOpen]) => !canOpen),
            onSelect: (event) => {
                event.preventDefault();
                if (opts.anchorFromCaret) {
                    file.setAnchorFromCaret();
                }
                else {
                    const trigger = event.currentTarget;
                    if (trigger)
                        file.setAnchorEl(trigger);
                }
                mutxt.voids.open.set(false);
                file.toggle();
            },
        };
    }
    itemEmbed(opts = {}) {
        const mutxt = this.mutxt;
        const embed = mutxt.voids.embed;
        return {
            name: 'Embed',
            text: 'iframe url media youtube tweet bookmark link preview',
            icon: () => React.createElement(EmbedIcon, null),
            disabled: ui_1.rsync.comp([embed.canOpen], ([canOpen]) => !canOpen),
            active: ui_1.rsync.comp([mutxt.caretEmbedUrl], ([url]) => !!url),
            onSelect: (event) => {
                event.preventDefault();
                if (opts.anchorFromCaret) {
                    embed.setAnchorFromCaret();
                }
                else {
                    const trigger = event.currentTarget;
                    if (trigger)
                        embed.setAnchorEl(trigger);
                }
                mutxt.voids.open.set(false);
                embed.toggle();
            },
        };
    }
    itemMath(_opts = {}) {
        const mutxt = this.mutxt;
        return {
            name: 'Equation',
            text: 'math equation formula latex mathlive tex displaystyle',
            icon: () => React.createElement(MathIcon, null),
            disabled: ui_1.rsync.comp([mutxt.readOnly], ([readOnly]) => !!readOnly),
            onSelect: (event) => {
                event.preventDefault();
                if (mutxt.readOnly.value)
                    return;
                mutxt.voids.open.set(false);
                (0, math_1.insertEmptyMathBlock)(mutxt);
                slate_react_1.ReactEditor.focus(mutxt.editor);
                mutxt.setFocused(true);
                mutxt.sync(true);
            },
        };
    }
}
exports.VoidMenu = VoidMenu;
